import { GET_AISLES } from "constants/aisles";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_AISLES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
